import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

class Popup extends Component {
  constructor (props) {
    super(props);

    this.state = {
      position: props.position
    };
  }

  componentWillReceiveProps (nextProps, nextContext) {
    if (nextProps.opened !== this.props.opened) {
      if (nextProps.opened) {
        this.setState({
          position: nextProps.position
        });
        this.props.onShow();
      } else {
        this.props.onHide();
      }
    }
  }

  calculateOffset () {
    const { direction, mainOffset, secondaryOffset } = this.props;

    const offsets = {
      'bottom-left': {
        marginTop: mainOffset,
        marginLeft: secondaryOffset
      },
      'bottom-center': {
        marginTop: mainOffset
      },
      'bottom-right': {
        marginTop: mainOffset,
        marginRight: secondaryOffset
      },
      'top-left': {
        marginBottom: mainOffset,
        marginLeft: secondaryOffset
      },
      'top-center': {
        marginBottom: mainOffset
      },
      'top-right': {
        marginBottom: mainOffset,
        marginRight: secondaryOffset
      },
      'right-top': {
        marginLeft: mainOffset,
        marginBottom: secondaryOffset
      },
      'right-center': {
        marginLeft: mainOffset
      },
      'right-bottom': {
        marginLeft: mainOffset,
        marginTop: secondaryOffset
      },
      'left-top': {
        marginRight: mainOffset,
        marginBottom: secondaryOffset
      },
      'left-center': {
        marginRight: mainOffset
      },
      'left-bottom': {
        marginRight: mainOffset,
        marginTop: secondaryOffset
      }
    };

    return offsets[direction];
  }

  render () {
    const props = this.props;
    const position = props.position || this.state.position;

    const style = {
      ...position,
      ...this.calculateOffset()
    };

    const clsNames = classNames('popup', 'base', {
      opened: props.opened,
      extended: props.extended,
      flat: props.flat,
      indentation: props.indentation,
      [props.direction]: !position
    }, props.className);

    return (
      <div
        className={clsNames}
        style={style}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {props.children}
      </div>
    );
  }
}

Popup.propTypes = {
  position: PropTypes.shape({
    top: PropTypes.number,
    left: PropTypes.number
  }),
  opened: PropTypes.bool,
  flat: PropTypes.bool,
  extended: PropTypes.bool,
  indentation: PropTypes.bool,    // +padding
  children: PropTypes.any,
  direction: PropTypes.oneOf([
    'bottom-left',
    'bottom-center',
    'bottom-right',
    'top-left',
    'top-center',
    'top-right',
    'right-top',
    'right-center',
    'right-bottom',
    'left-top',
    'left-center',
    'left-bottom'
  ]),
  mainOffset: PropTypes.number,
  secondaryOffset: PropTypes.number,
  className: PropTypes.string,
  onShow: PropTypes.func,
  onHide: PropTypes.func
};

Popup.defaultProps = {
  className: '',
  direction: 'bottom-left',
  flat: false,
  indentation: true,
  mainOffset: 0,
  secondaryOffset: 0,
  onShow: () => {},
  onHide: () => {}
};

export default Popup;



// WEBPACK FOOTER //
// ./src/ui/Popup/Popup.js